import CreateSiteV2 from "../../forms/CreateSiteV2";

const FreezerFrostCreate = () => <CreateSiteV2 mode="freezer" />;

export default FreezerFrostCreate;
